import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import UserApi from '../api/userApi';
import RoleApi from '../api/roleApi';


function getAllUsersSuccess(users) {
    return {type: types.GET_ALL_USERS_SUCCESS, users};
}

function getAllUsersFailure(error) {
    return {type: types.GET_ALL_USERS_FAILURE, error};
}

function getAllUsers() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return UserApi.getAllUsers().then(users => {
            dispatch(getAllUsersSuccess(users));
        }).catch(error => {
            dispatch(getAllUsersFailure({error: error.text}));
        });
    };
}

function store(user) {
    return function (dispatch) {
        return UserApi.store(user).then(user => {
            dispatch(storeUserSuccess(user));
        }).catch(error => {
            dispatch(storeUserFailure({error: error.text}));
        });
    };
}

function storeUserSuccess(user) {
    return {type: types.STORE_USER_SUCCESS, user};
}

function storeUserFailure(error) {
    return {type: types.STORE_USER_FAILURE, error};
}

function update(user) {
    return function (dispatch) {
        return UserApi.update(user).then(user => {
            dispatch(updateUserSuccess(user));
        }).catch(error => {
            dispatch(updateUserFailure({error: error.text}));
        });
    };
}

function updatePassword(user) {
    return function (dispatch) {
        return UserApi.updatePassword(user).then(user => {
            //dispatch(updateUserSuccess(user));
        }).catch(error => {
            //dispatch(updateUserFailure({error: error.text}));
        });
    };
}

function updateUserSuccess(user) {
    return {type: types.UPDATE_USER_SUCCESS, user};
}

function updateUserFailure(error) {
    return {type: types.UPDATE_USER_FAILURE, error};
}

function logout() {
    return function (dispatch) {
        localStorage.removeItem('me');
        dispatch(logoutSuccess());
    };
}

function logoutSuccess() {
    return {type: types.USER_LOGOUT_SUCCESS};
}

function getAllRoles() {
    return function (dispatch) {
        return RoleApi.getAll().then(roles => {
            dispatch(getAllRolesSuccess(roles));
        }).catch(error => {
            throw(error);
        });
    };
}

function getAllRolesSuccess(roles) {
    return {type: types.GET_ALL_ROLES_SUCCESS, roles};
}

export {
    getAllRoles,
    getAllUsers,
    store,
    update,
    updatePassword,
    logout
};


/** WEBPACK FOOTER **
 ** ./src/actions/userAction.js
 **/